import { IntervalEnum } from "../../enums/intervals-enum";
import { BaseModel } from "../base.model";
import { TenantBaseModel } from "../tenant-base.model";

export class FiniteStateMachineModel extends BaseModel{
    name?: string; 
    isEnabled?: boolean; 
    order?: number;
    lastActive?: string;
    coverPhotoFileId?: string;
    profilePhotoFileId?: string;
    tenantBase?: TenantBaseModel;
    version?: string;
    interval?: IntervalEnum;
}
